var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CloudFrontContainer',{attrs:{"project":_vm.selectedProject,"month":_vm.selectedMonth}})}
var staticRenderFns = []

export { render, staticRenderFns }